var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.677,
    height: 252.122,
    viewBox: "0 0 213.677 252.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(-7218.5 -13643.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318",
    transform: "translate(7219 13770.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(0 62.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M16.629,62.807A16.624,16.624,0,0,1,3.849,35.546h0L25.554,0,57.77,4.352,53.638,40.535,57.77,62.807Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x1: 26.324,
    transform: "translate(16.628 29.554)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(154.908 55.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M0,69.808,4.134,47.521,0,11.348,26.221,0,53.548,42.107a16.629,16.629,0,0,1-12.407,27.7Z",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 32.991,
    transform: "translate(8.152 36.552)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317",
    transform: "translate(9.261 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M377.635,298.792s-34.819,0-60.452,25.207v70.645s122.666,1.867,122.666,0,.033-75.313.033-75.313S414.787,298.792,377.635,298.792Z",
    transform: "translate(-283.493 -298.792)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M327.219,316.374s-18.926,15.279-38.876,48.921c0,0,4.3,19.467,41.466,22.447Z",
    transform: "translate(-288.343 -295.835)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M422.59,316.374s18.924,15.279,38.876,48.921c0,0-4.3,19.467-41.467,22.447Z",
    transform: "translate(-266.201 -295.835)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "translate(7261.952 13813.681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 122.666,
    height: 81.545,
    rx: 4.765,
    transform: "translate(0 0)",
    fill: "#25292b",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 7.518,
    cy: 7.518,
    r: 7.518,
    transform: "translate(53.816 33.255)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(7284.864 13643.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_19",
    "data-name": "Union 19",
    d: "M0,22.572A92.924,92.924,0,0,1,22.454,15.8V0H46.518V15.422a133.246,133.246,0,0,1,22.3,5.56S65.874,39.141,32.734,39.141,0,22.572,0,22.572Z",
    transform: "translate(3.641 111.58)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M358.13,284.807s2.121,13.392,12.21,13.635c13.245.319,13.028-13.039,13.028-13.039s-1.806,3.93-12.047,3.944C359.9,289.363,358.13,284.807,358.13,284.807Z",
    transform: "translate(-333.209 -174.684)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 33.463,
    cy: 34.326,
    rx: 33.463,
    ry: 34.326,
    transform: "translate(4.714 32.029)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M15.154,60.021a42.181,42.181,0,0,1-3.37-9.539,5.975,5.975,0,0,1-4.4.949c-7.455-1.538-9.7-13.606-4.733-15.492a5.976,5.976,0,0,1,7.134,1.618c-.5-5.707-.437-9.928-.437-9.928S9.352,0,38.145,0C68.47,0,67.571,27.487,67.571,27.487c0,2.651-.092,6.294-.417,10.323.376-.534,2.781-3.6,7.327-1.871,4.97,1.886,2.721,13.954-4.733,15.492a5.975,5.975,0,0,1-4.405-.956A43.312,43.312,0,0,1,61.762,61c-4.709,9.021-12.5,13.872-22.7,14.163-.359.01-.716.016-1.068.016C28.317,75.183,21.034,71.313,15.154,60.021Z",
    transform: "translate(0 40.992)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M345.629,261.4s6.147-13.484.724-23.191C346.353,238.209,341.444,253.824,345.629,261.4Z",
    transform: "translate(-335.596 -182.521)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M394.587,261.4s-6.147-13.484-.724-23.191C393.863,238.209,398.773,253.824,394.587,261.4Z",
    transform: "translate(-327.575 -182.521)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M382.274,226.957s-2.834,16.345,14.068,23.775C396.342,250.732,395.647,231.6,382.274,226.957Z",
    transform: "translate(-329.179 -184.414)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M392.319,229.642s-2.53,16.309-24.7,12.674c-17.258-2.829-22.525,10.363-22.525,10.363s-3.062-24.522,24.8-29.539C369.891,223.14,384.145,223.065,392.319,229.642Z",
    transform: "translate(-335.419 -185.056)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "translate(6.584 65.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326",
    transform: "translate(16.382 13.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M361.72,260.929a2.632,2.632,0,1,1-2.632-2.632A2.632,2.632,0,0,1,361.72,260.929Z",
    transform: "translate(-356.456 -258.297)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.632,
    cy: 2.632,
    r: 2.632,
    transform: "translate(24.369)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M368.009,265.458l0,3.551a1.386,1.386,0,0,0,1.646,1.389l1.888-.4",
    transform: "translate(-338.131 -243.221)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M367.7,254.02l-15.952,1.917s1.28-4.231,7.8-4.958S367.7,254.02,367.7,254.02Z",
    transform: "translate(-340.866 -245.672)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M373.277,254.02l15.952,1.917s-1.28-4.231-7.8-4.958S373.277,254.02,373.277,254.02Z",
    transform: "translate(-337.245 -245.672)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    d: "M11.614,0A11.614,11.614,0,1,1,0,11.614,11.627,11.627,0,0,1,11.614,0Zm0,21.767A10.154,10.154,0,1,0,1.46,11.614,10.165,10.165,0,0,0,11.614,21.767Z",
    transform: "translate(0 16.424) rotate(-45)",
    fill: "#962cc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    d: "M11.614,0A11.614,11.614,0,1,1,0,11.614,11.627,11.627,0,0,1,11.614,0Zm0,21.767A10.154,10.154,0,1,0,1.46,11.614,10.165,10.165,0,0,0,11.614,21.767Z",
    transform: "translate(33.286 25.072) rotate(-76.771)",
    fill: "#962cc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M374.408,262.223c-1.477-1.673-2.943-2.47-4.357-2.371a5.377,5.377,0,0,0-3.543,2.287l-1.223-.8a6.778,6.778,0,0,1,4.65-2.945c1.9-.139,3.77.823,5.567,2.86Z",
    transform: "translate(-338.589 -244.411)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M361.68,273.807s1.6,2.072,8.713,2.072c6.468,0,9.4-2.072,9.4-2.072",
    transform: "translate(-339.196 -241.817)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 21.843,
    cy: 21.843,
    r: 21.843,
    transform: "translate(28.315 0)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M393.683,265.317a.453.453,0,0,1-.408-.65c1.6-3.315,3.571-4.5,4.945-4.906a4.852,4.852,0,0,1,2.723-.067.453.453,0,0,1-.285.86,4.05,4.05,0,0,0-2.233.092c-1.7.526-3.2,2.053-4.334,4.415A.453.453,0,0,1,393.683,265.317Z",
    transform: "translate(-327.306 -178.935)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M347.1,265.317a.453.453,0,0,1-.408-.256c-1.139-2.362-2.637-3.889-4.334-4.415a4.048,4.048,0,0,0-2.233-.092.453.453,0,0,1-.284-.86,4.852,4.852,0,0,1,2.723.067c1.374.408,3.347,1.591,4.945,4.906a.453.453,0,0,1-.408.65Z",
    transform: "translate(-336.338 -178.935)",
    fill: "#131313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.5d11e46810b38441fa3d7296d4a2802f.svg";
export { ForwardRef as ReactComponent };